<template>
  <div class="d-flex align-items-center user_question_container mb-3 flex-row-reverse">
    <div class="rounded-circle p-2 user_icon ai_bg_card" :style="{ background: `${primaryColor}` }">
      <span v-if="userName" class="text-white"> {{ userName }}</span>
      <GuestIcon theme-color="#fff" v-else />
    </div>
    <div>
      <p class="mb-1 text-right _dynamic_text_color" :class="{ gradient_text_white: isGradient }">
        <small>{{ initialName || initial }}</small>
      </p>
      <div class="user_question ai_bg_card" :style="{ background: `${primaryColor}`, color: '#fff' }">
        <p v-if="userinput.customUIUserResponse" class="user_response mb-0 text-white"
          :class="{ 'text-white': isGradient }">
          {{
            userinput.customUIUserResponse
              ? userinput.customUIUserResponse
              : userinput.EventLabel
          }}
        </p>
        <p v-else class="user_response mb-0 text-white">
          {{ userinput.UserResponse ? userinput.UserResponse : userinput.EventLabel }}
        </p>
      </div>
    </div>

  </div>
</template>
<script>
import { getInitials } from '../../../../../../js/services/CommonUtility';
import GuestIcon from '../../ChatIcons/GuestIcon.vue';

export default {
  data() {
    return {
      primaryColor: '',
      userInfo: (window.userDetails.firstname + ' ' + window.userDetails.lastname).trim() || 'Guest',
      initial: window.initialName || '',
      nameInitial: '',
    }
  },
  props: {
    question: {
      type: String,
      default: '',
    },
    userinput: {
      default: '',
      required: false,
    },
    requesttime: {
      default: '',
      required: false,
    },
    index: {
      default: '',
      required: false,
    },
    design: {
      default: null,
      required: false,
    },
    initialName: {
      default: '',
      required: false,
    },
    chatThemeSettings: {
      type: Object,
      default: {},
    },
  },
  components: {
    GuestIcon,
  },
  mounted() {
    this.primaryColor = this.chatThemeSettings?.primeColor || window.primaryColor;
  },
  computed: {
    userName() {
      if ((this.initialName && this.initialName != 'Guest') || (this.initial && this.initial != 'Guest')) {
        this.nameInitial = getInitials(this.initialName || this.initial);
        return this.nameInitial;
      }
      return null;
    },
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
}
</script>
<style scoped>
.user_question_container {
  gap: 13px;
}

.user_question_container em {
  color: #fff;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
}

.user_question {
  background: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  display: inline-block;
  max-width: 500px;
}

.user_question p {
  font-weight: 500;
}

.user_icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
